import posthog from "posthog-js";

const POSTHOG_KEY = "phc_N0ZjMqsa2oHF5xcLnWzYwkuPkfTSHv7PSZA44olt2wU";
const POSTHOG_HOST = "https://d.proxidize.com";

let initialPageviewUrl: string | null = null;

// Idempotent — safe to call from both the provider and the consent banner.
// Never called for visitors whose stored consent is "rejected", so they
// generate zero PostHog network traffic.
export function initPostHog() {
  if (posthog.__loaded) return;
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    ui_host: "https://eu.posthog.com",
    capture_pageview: false,
    capture_pageleave: true,
    person_profiles: "identified_only",
    cross_subdomain_cookie: true,
    session_recording: {
      maskAllInputs: true,
      maskInputOptions: { password: true },
    },
    capture_exceptions: true,
  });
  // The route-change effect in PostHogPageView runs before init on the first
  // load and skips while the SDK isn't loaded, so the initial pageview is
  // captured here instead.
  initialPageviewUrl = `${window.location.origin}${window.location.pathname}${window.location.search}`;
  posthog.capture("$pageview", { $current_url: initialPageviewUrl });
}

// Lets PostHogPageView skip its first run when init already captured the
// same URL (effect ordering differs between first load and route changes).
// Compared without the trailing slash — usePathname and location.pathname
// can disagree on it.
export function consumeInitialPageview(url: string) {
  const normalize = (u: string) => u.replace(/\/(?=\?|$)/, "");
  const alreadyCaptured =
    initialPageviewUrl !== null && normalize(initialPageviewUrl) === normalize(url);
  initialPageviewUrl = null;
  return alreadyCaptured;
}
